import {SettingsNavigationProperty} from "@pata/settings";
import {getTranslations} from "next-intl/server";

export default async function fetchServices(): Promise<SettingsNavigationProperty[]> {
    const t = await getTranslations('Navigation')
    
    return [
        { name: t('logging'), path: "/logging", htmlId: 35 },
        { name: t('forest-management'), path: "/forest-management", htmlId: 36 },
        { name: t('wood-sawmill'), path: "/wood-sawmill", htmlId: 34 },
    ]
}